import { createResourceKeys } from "@/lib/resource-context";

export const apiKeysKeys = {
  ...createResourceKeys("api_keys"),

  personal: () => ["personal-api-keys"] as const,
};
